import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(default)/(admin)/Organisation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/components/Project.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptionParamFilter","default"] */ "/app/src/lib/components/QueryParamFilter.tsx");
